// ============================================================
// TOGGLE PLATINUM PRICE MODIFICATION
// ============================================================
// Set to true to apply platinum price modification (0.1)
// Set to false to use actual prices from API
// Simply comment/uncomment the line below to toggle
// ============================================================

// const APPLY_PLATINUM_MODIFICATION = true;
const APPLY_PLATINUM_MODIFICATION = false;

// ============================================================

// Utility function to modify package prices
// Keeps all package prices as is, but changes Platinum price to 0.1
// Only applies modification if APPLY_PLATINUM_MODIFICATION is true

export const modifyPackagePrices = (packages) => {
  if (!Array.isArray(packages)) return packages;
  
  // If modification is disabled, return packages as is
  if (!APPLY_PLATINUM_MODIFICATION) {
    return packages;
  }
  
  // Apply modification to Platinum package
  return packages.map((pkg) => {
    if (pkg.name === "Platinum") {
      return {
        ...pkg,
        details: pkg.details?.map((detail) => ({
          ...detail,
          price: 0.1,
        })) || [],
      };
    }
    return pkg;
  });
};
